export default __webpack_public_path__ + "static/media/wallpaper-Elf-02.506e3970.png";